module.exports = __webpack_public_path__ + "static/media/alerta-infracciones-verde.e562e91a.svg";